import { MAX_FILES_UPLOADED_IN_MESSAGE } from '@/constants/config';

export function getComposerFileLimitError(count, t) {
  if (count <= MAX_FILES_UPLOADED_IN_MESSAGE) return null;
  const fallback = 'You selected %COUNT% files. You can attach up to %MAX% per message. Remove files before sending.';
  const translated = t?.('chatInput.tooManyFiles');
  return (translated && translated !== 'chatInput.tooManyFiles' ? translated : fallback)
    .replace('%COUNT%', count)
    .replace('%MAX%', MAX_FILES_UPLOADED_IN_MESSAGE);
}
